import AbstractNetworkStatus from '../all/AbstractNetworkStatus';
import logger from 'src/utils/logger/logger';

class OperaNetworkStatus extends AbstractNetworkStatus {

  constructor() {
    super();
  }

  isOnline() {
    logger.debug('[NetworkStatus] checking Opera...');
    // Opera will not notify it immediately when we connect wifi/ethernet again after a previous disconnect,
    // we will wait until opera says there is internet connection again :( (wait about 5-10 mins after connect network again)
    return this.onlineByAjax();
  }

}

export default OperaNetworkStatus;



// WEBPACK FOOTER //
// ./src/devices/opera/NetworkStatus.js